import { Locale, SubtitleTextSizes } from '../typings';

export const fr_CA: Locale = {
  name: 'fr_CA',
  translations: {
    General: {
      On: 'Activé',
      Off: 'Désactivé',
    },
    BottomControls: {
      NowPlaying: 'En cours de lecture',
      PlayingOn: (device: string) => `Lecture sur ${device}`,
    },
    ContextMenuOverlay: {
      Version: (version: string) => `Version: ${version}`,
      PoweredByBeachbody: 'Propulsé par Beachbody',
    },
    ErrorOverlay: {
      ErrorCode: (code: number) => `Erreur ${code}`,
      CannotBePlayed: 'Cette vidéo ne peut pas être lue.',
      PleaseTryAgain: 'Veuillez réessayer ultérieurement.',
    },
    LanguageOptions: {
      Subtitles: 'Sous-titres',
      SubtitleOptions: 'Options de sous-titres',
      Audio: 'Audio',
    },
    SubtitleOptions: {
      FontSize: 'Taille de la police',
      TextSizeOption: textSize => {
        switch (textSize) {
          case SubtitleTextSizes.Smallest:
            return 'La plus petite';
          case SubtitleTextSizes.Small:
            return 'Petite';
          case SubtitleTextSizes.Normal:
            return 'Normale';
          case SubtitleTextSizes.Large:
            return 'Grande';
          case SubtitleTextSizes.Largest:
            return 'La plus grande';
          default:
            return 'Normale';
        }
      },
      FontColor: 'Couleur de la police',
      BoldText: 'Texte en gras',
    },
    ModifierIndicator: {
      Modifier: 'Variante',
    },
    ResumeOverlay: {
      AboutToPlay: 'Sur le point de jouer',
      ResumeVideo: 'Reprendre la vidéo',
      StartOver: 'Recommencer',
    },
  },
};
